<template>
    <div ref="tableRef">
      <LedgerRow
          v-for="(key, i) in ledgerKeys"
          :key="i"
          :ledger="ledgers[key]"
          :keyName="key"
          :contactProfiles="contactProfiles"
          :businesses="businesses"
          :costCentres="costCentres"
          :projects="projects"
          :projectActivity="projectActivity"
          :cashAndBack="cashAndBack"
          @onOpenEditItem="onOpenEditItem"
          @onclickUpdate="onclickUpdate"
          @onclickDelete="onclickDelete"
      />
  </div>
</template>

<script>
import LedgerRow from '@/components/molecule/cash-bank-import/LedgerRow.vue'
import { ref } from 'vue';
import useDetectOutsideClick from '@/services/useDetectOutsideClick';

export default {
    name: 'Ledger',
    emits:['onclickUpdate','onclickDelete'],
    components: {
        LedgerRow
    },
    computed: {
        ledgerKeys () {
            return this.ledgers ? Object.keys(this.ledgers) : []
        }
    },
    methods: {
        onclickUpdate(data) {
            this.$emit('onclickUpdate', data)
        },

        onclickDelete(data) {
            this.$emit('onclickDelete', data)
        },
         onOpenEditItem(keyName){
          this.resetItemList(keyName)
        },

    },
    setup(props) {
      const tableRef = ref(null)

      const resetItemList = (keyName = null) => {
        let ledgers = props.ledgers;
        Object.keys(ledgers).forEach((voucherKey) => {
          if (voucherKey === keyName) {
            ledgers[voucherKey].is_edit = true;
          }
          if (voucherKey !== keyName) {
            ledgers[voucherKey].is_edit = false;
          }
        });

      };

      useDetectOutsideClick(tableRef, resetItemList);

      return {
        tableRef,
        resetItemList
      };
    },
    props: {
        ledgers: Object,
        contactProfiles:Array,
        businesses:Array,
        costCentres:Array,
        projects:Array,
        projectActivity:Array,
        cashAndBack:Array,
    }
}
</script>
